import { ActionIcon, Center, Paper } from '@mantine/core';
import { IconCaretUp } from '@tabler/icons-react';
import { MouseEventHandler } from 'react';

import classes from './../Sidebar.module.css';

interface ScrollUpProps {
  onScrollUp: () => void;
}

export function ScrollUp({ onScrollUp }: ScrollUpProps) {
  const onClick: MouseEventHandler = ev => {
    ev.stopPropagation();
    onScrollUp();
  };

  return (
    <Paper
      className={classes.scrollUp}
      onClick={onClick}
      bg="white"
      shadow="xs"
      py="2px"
      mb="5px"
      radius="xs"
    >
      <Center>
        <ActionIcon
          size={24}
          variant="outline"
          aria-label="jos"
        >
          <IconCaretUp
            onClick={onClick}
            style={{ width: '70%', height: '70%' }}
            stroke={1.5}
          />
        </ActionIcon>
      </Center>
    </Paper>
  );
}
